import { ActivatedRoute } from '@angular/router';

export class RouterPathHelper {
    constructor(private  route: ActivatedRoute) { }

    getNavigationPath(processAppraiseeDurationId: number, childrenComponentName: string): string {
        const parentUrl = this.route.snapshot.parent.routeConfig.path;
        const childComponentRouterPath = this.route.snapshot.parent.routeConfig.children
        .find(x => [...x.path.split('/')].shift() === childrenComponentName).path;
        const componentPath = [...childComponentRouterPath.split('/')].shift();
        return `${parentUrl}/${componentPath}/${processAppraiseeDurationId}`;
      }
}
